import { render, staticRenderFns } from "./CbsFormDesignerColumn.vue?vue&type=template&id=cfd9d2f0&scoped=true"
import script from "./CbsFormDesignerColumn.vue?vue&type=script&lang=js"
export * from "./CbsFormDesignerColumn.vue?vue&type=script&lang=js"
import style0 from "./CbsFormDesignerColumn.vue?vue&type=style&index=0&id=cfd9d2f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd9d2f0",
  null
  
)

export default component.exports